import { API_BASE_URL } from "../../constants/index";
import { buildUrl } from "../../utilities/index";
import HttpInterface from "../../helpers/HttpInterface";

export class AddressBookService {
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  all(params = {}) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      buildUrl(`${API_BASE_URL}/registry-service/address-book`, params),
      requestOptions
    );
  }

  get(id) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/registry-service/address-book/${id}`,
      requestOptions
    );
  }

  create(addressBook) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(addressBook),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/registry-service/address-book`,
      requestOptions
    );
  }

  edit(addressBook) {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(addressBook),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/registry-service/address-book/${addressBook.id}`,
      requestOptions
    );
  }

  delete(id) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/registry-service/address-book/${id}`,
      requestOptions
    );
  }
}
